// custom map plugin
function CustomMap(opt) {
    this.options = jQuery.extend({
        holder: null,
        map: '.map-canvas',
        startCooords: [46.818188, 8.227512],
        defaultOptions: {
            maxZoom: 16,
            zoom: 12
        }
    }, opt);
    this.init();
}
CustomMap.prototype = {
    init: function() {
        if (this.options.holder) {
            this.findElements();
            this.createMap();
            this.makeCallback('onInit', this);
        }
    },
    findElements: function() {
        this.holder = jQuery(this.options.holder);
        this.map = this.holder.find(this.options.map);
    },
    createMap: function() {
        var self = this,
            usRoadMapType;

        this.mapOptions = jQuery.extend({}, this.options.defaultOptions, {
            center: new google.maps.LatLng(this.options.startCooords[0], this.options.startCooords[1]),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            tilt: 45
        });
        this.mapCanvas = new google.maps.Map(this.map[0], this.mapOptions);
        this.loadMarkersJSON(this.map.attr('data-markers'), function(data) {
            self.prepareMarkers(data);
        });
    },
    loadMarkersJSON: function(url, complete) {
        jQuery.getJSON(url, function(data) {
            complete(data);
        });
    },
    prepareMarkers: function(data) {
        var self = this,
            currentIndex = 0;

        this.markers = [];
        jQuery.each(data.markers, function(key, val) {
            currentIndex++;
            var newMarker = {
                position: new google.maps.LatLng(val.location[0], val.location[1]),
                markerHTML: val.innerHTML
            };
            if (val.imageURL && val.imageURL.length) {
                newMarker.icon = val.imageURL;
            }
            
            self.addMarker(newMarker)
        });
    },
    addMarker: function(obj) {
        var self = this;
        var markerOptions = jQuery.extend({}, obj, { map: this.mapCanvas });
        var marker = new google.maps.Marker(markerOptions);

        self.mapCanvas.setCenter(marker.getPosition());
    },
    makeCallback: function(name) {
        if(typeof this.options[name] === 'function') {
            var args = Array.prototype.slice.call(arguments);
            args.shift();
            this.options[name].apply(this, args);
        }
    },
    getDirrectionLink: function(coordinates) {
        return 'https://maps.google.com/maps?daddr=' + coordinates.lat() + ','  + coordinates.lng();
    }
};